import tw from 'twin.macro';

/**
 * Wrapper
 * Main container for the login form.
 * Adds horizontal padding (responsive) and bottom padding.
 */
export const Wrapper = tw.div`lg:px-6 px-2 pb-10`;

/**
 * Welcome
 * Heading for the welcome message.
 * Centered, primary color, bold, uppercase, and responsive sizing/margin.
 */
export const Welcome = tw.h3`text-center text-primary 
lg:text-lg lg:-mt-4 -mt-2 font-bold tracking-wide uppercase`;

/**
 * Title
 * Subheading for the login form.
 * Responsive left margin, bottom margin, and font size.
 */
export const Title = tw.h4`lg:ml-4 mb-4 lg:mb-6 lg:text-xl 2xl:text-2xl tracking-wide`;

/**
 * Form
 * Styles the form container.
 * Responsive width and flex column layout.
 */
export const Form = tw.form`lg:w-11/12 w-full flex flex-col`;

/**
 * Label
 * Styles for form labels.
 * Base font size and bold.
 */
export const Label = tw.label`text-base font-bold`;

/**
 * Input
 * Styles for input fields.
 * Bordered, rounded, and padded.
 */
export const Input = tw.input`border border-gray-700 rounded-lg p-2`;

/**
 * LoginButton
 * Styles for the login button.
 * Centered, bold, rounded, responsive padding and font size, 
 * blue background, and white text.
 */
export const LoginButton = tw.button`text-center
 font-semibold lg:py-3 py-2 text-white! rounded-lg lg:mt-6 mt-4 lg:text-xl
  text-base bg-[#1a73e3] text-gray-800`;
